import React from 'react'
import styles from './error_message.module.scss'
import { Button } from 'antd'
import { auth } from '@BUP/configs/Firebase'
import { FrownOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import useSignOut from '@BUP/hooks/user/use-sign-out'

const ErrorMessage = ({ message, withSignOut = false }) => {
  const [t] = useTranslation()
  const { signOut: handleOnClickSignOut, loading: signOutLoading, error: signOutError } = useSignOut(auth)

  if (signOutLoading) return <p>{t('common.resources.session.actions.destroy.loading')}</p>
  if (signOutError) return <p>{t('common.resources.session.actions.destroy.failure', { context: 'with-message', message: signOutError.message })}</p>

  return (
    <div className={styles.error_message_container}>
      <div className={styles.icon_wrapper}>
        <FrownOutlined />
      </div>
      <div className={styles.text_wrapper}>
        <h2>{message || t('nav.error.errorMessage')}</h2>
      </div>
      <div className={styles.button_wrapper}>
        {withSignOut
          ? (
            <Button
              style={{ width: 150, fontWeight: 'bold' }}
              type='primary'
              shape='round'
              onClick={handleOnClickSignOut}
            >
              {t('common.resources.session.actions.destroy.submit')}
            </Button>
            )
          : (
            <Button
              size='large'
              onClick={() => window.location.reload()}
            >
              {t('nav.error.buttonError')}
            </Button>
            )}
      </div>
    </div>
  )
}

export default ErrorMessage
